<!-- <div class="card">
    <div class="card-body"> -->
        <tabset [justified]="true" class="nav-tabs nav-tabs-custom nav-justified" >
            <tab heading="Timeline" (selectTab)="onTabSelect($event)" [active]="activeTab === 'Timeline'">
                @if(activeTab == 'Timeline'){
                    <ng-template [ngTemplateOutlet]="Timeline"></ng-template>
                }
            </tab>
            <tab heading="Comments" (selectTab)="onTabSelect($event)" [active]="activeTab === 'Comments'">
                @if(activeTab == 'Comments'){
                    <ng-template [ngTemplateOutlet]="Comments"></ng-template>
                }
            </tab>
            <tab heading="Files" (selectTab)="onTabSelect($event)" [active]="activeTab === 'Files'">
                @if(activeTab == 'Files'){
                    <ng-template [ngTemplateOutlet]="Files"></ng-template>
                }
            </tab>
            @if(relatedConditions?.length && (relatedConditions[0].relatedTypeId == 1 || relatedConditions[0].relatedTypeId == 3 || relatedConditions[0].relatedTypeId == 13)){
                <tab heading="Shared" (selectTab)="onTabSelect($event)" [active]="activeTab === 'Shared'">
                    @if(activeTab == 'Shared'){
                        <ng-template [ngTemplateOutlet]="SharedWith"></ng-template>
                    }
                </tab>
            }
        </tabset>

        <ng-template #Timeline>
            <app-utility-timeline [relatedConditions]="relatedConditions"></app-utility-timeline>
        </ng-template>
        
        <ng-template #Files>
            <app-file-attachment [relatedConditions]="relatedConditions"></app-file-attachment>
        </ng-template>
        
        <ng-template #Comments>
            <app-comments [relatedConditions]="relatedConditions"></app-comments>
        </ng-template>

        <ng-template #SharedWith>
            @if(relatedConditions?.length){
                <app-sharedwith [relatedTypeId]="relatedConditions[0].relatedTypeId" [recordId]="relatedConditions[0].recordId"></app-sharedwith>
            }
        </ng-template>

